/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CadenceCalendarItem
 */
export interface CadenceCalendarItem {
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    definitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    scheduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    scheduleBlockId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    cadenceTier?: string;
    /**
     * 
     * @type {Date}
     * @memberof CadenceCalendarItem
     */
    scheduledFor?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CadenceCalendarItem
     */
    dueAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CadenceCalendarItem
     */
    horizonBucket?: string;
}

/**
 * Check if a given object implements the CadenceCalendarItem interface.
 */
export function instanceOfCadenceCalendarItem(value: object): value is CadenceCalendarItem {
    return true;
}

export function CadenceCalendarItemFromJSON(json: any): CadenceCalendarItem {
    return CadenceCalendarItemFromJSONTyped(json, false);
}

export function CadenceCalendarItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CadenceCalendarItem {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'scheduleBlockId': json['scheduleBlockId'] == null ? undefined : json['scheduleBlockId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'title': json['title'] == null ? undefined : json['title'],
        'cadenceTier': json['cadenceTier'] == null ? undefined : json['cadenceTier'],
        'scheduledFor': json['scheduledFor'] == null ? undefined : (new Date(json['scheduledFor'])),
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'horizonBucket': json['horizonBucket'] == null ? undefined : json['horizonBucket'],
    };
}

export function CadenceCalendarItemToJSON(json: any): CadenceCalendarItem {
    return CadenceCalendarItemToJSONTyped(json, false);
}

export function CadenceCalendarItemToJSONTyped(value?: CadenceCalendarItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'definitionId': value['definitionId'],
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'scheduleId': value['scheduleId'],
        'scheduleBlockId': value['scheduleBlockId'],
        'dimensionId': value['dimensionId'],
        'dimensionKey': value['dimensionKey'],
        'title': value['title'],
        'cadenceTier': value['cadenceTier'],
        'scheduledFor': value['scheduledFor'] == null ? undefined : ((value['scheduledFor']).toISOString()),
        'dueAt': value['dueAt'] == null ? undefined : ((value['dueAt']).toISOString()),
        'horizonBucket': value['horizonBucket'],
    };
}

